// extracted by mini-css-extract-plugin
export default {"img-container":"styles_img-container__9yIOg","bottom-line":"styles_bottom-line__SPvan"};